import { render, staticRenderFns } from "./SolinfaCliente.vue?vue&type=template&id=3c2de088"
import script from "./SolinfaCliente.vue?vue&type=script&lang=js"
export * from "./SolinfaCliente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports